import { useCallback, useState, useRef, ChangeEvent, DragEvent } from 'react';
import { Image, Delete } from '@mui/icons-material';
import useStyles from './styles';

import Colors from '../../entities/colors';

export const Upload = ({
  onUpload,
  file,
}: {
  onUpload: (file: File | null, base64?: string | ArrayBuffer | null) => any;
  file?: string | ArrayBuffer | File | null;
}): JSX.Element => {
  const classes = useStyles();
  const [preview, setPreview] = useState(file);
  const [dragging, setDragging] = useState(false);
  const inputFile = useRef<any>(null);

  const [dragCounter, setDragCounter] = useState(0);

  const handleDragEnter = (event: DragEvent) => {
    event.stopPropagation();
    event.preventDefault();

    setDragCounter(dragCounter + 1);

    setDragging(true);
  };

  const handleImageChange = useCallback((currentFile: File) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      onUpload(currentFile, reader.result);
      setPreview(reader.result);
    };

    reader.readAsDataURL(currentFile);
  }, [onUpload]);

  const handleDrop = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();

    setDragging(false);
    setDragCounter(0);
    const files = event.dataTransfer?.files;

    handleImageChange(files[0]);
  };

  const handleDragLeave = (event: DragEvent<HTMLDivElement>) => {
    event.stopPropagation();
    event.preventDefault();

    const currentCounter = dragCounter - 1;

    if (currentCounter === 0) {
      setDragging(false);
    }
    setDragCounter(currentCounter);
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();

    const files = event.target?.files || [];

    handleImageChange(files[0]);
  };

  const handleRemoveImg = useCallback(() => {
    setPreview(null);
    onUpload(null, null);
  }, [onUpload]);

  const renderPreview = useCallback(() => {
    const fileUrl = preview instanceof File ? URL.createObjectURL(preview) : preview;

    return (
      <div onClick={() => handleRemoveImg()} style={{ backgroundImage: `url(${fileUrl})` }} className={classes.preview}>
        <div>
          <Delete sx={{ fontSize: '52px', color: Colors.N100 }} />
        </div>
      </div>
    );
  }, [preview, classes.preview, handleRemoveImg]);

  const renderDefaultContent = useCallback(
    () => (
      <div>
        <Image sx={{ fontSize: '52px', color: Colors.N100 }} />
        <h4 className={classes.helpText}>
          Arraste sua imagem aqui, ou{' '}
          <div className={classes.link} onClick={() => inputFile?.current?.click()}>
            carregue
          </div>
        </h4>
        <h5 className={classes.fileTypes}>Arquivos suportados: JPG, JPEG, PNG</h5>
      </div>
    ),
    [classes.fileTypes, classes.link, classes.helpText]
  );

  return (
    <div className={classes.root}>
      <input
        ref={inputFile}
        style={{ visibility: 'hidden', width: 0, height: 0 }}
        onChange={handleChange}
        type="file"
      />
      <div className={classes.dragContainer}>
        <div
          className={dragging ? classes.dragging : classes.dragArea}
          onDragEnter={handleDragEnter}
          onDragLeave={handleDragLeave}
          onDragOver={(e) => e.preventDefault()}
          onDrop={handleDrop}
        >
          {file && preview ? renderPreview() : renderDefaultContent()}
        </div>
      </div>
    </div>
  );
};

export default Upload;
